import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { productService } from "../services/product.service";
import { handleImageError } from "../utils/product";
import ProductCard from "../components/ui/ProductCard";

const ProductList = () => {
  const { categoryName } = useParams(); // URL’den alt kategori slug geliyor
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [formFilter, setFormFilter] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const pageSize = 9;

  // Başlık için slug → normal metin çevirici
  const readableCategory = categoryName
    ? categoryName.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Ürünler";

  // FORM FİLTRE
  useEffect(() => {
    if (!formFilter) {
      setFiltered(products);
    } else {
      setFiltered(products.filter((p) => p.form === formFilter));
    }
    setPage(1);
  }, [formFilter, products]);

  const totalPage = Math.ceil(filtered.length / pageSize);
  const paginatedProducts = filtered.slice((page - 1) * pageSize, page * pageSize);

  // ÜRÜNLERİ FIRESTORE'DAN ÇEK (Unified Service)
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      let data = [];
      if (categoryName) {
        data = await productService.getProductsByCategory(categoryName);
      } else {
        // If "Tüm Ürünler", fetch all
        // We might want to filter only active ones here too if getAllProducts returns draft
        // But for now, let's assume we want all active products roughly.
        // Actually, productService.getAllProducts is tailored for Admin (shows everything).
        // Let's rely on category fetching or add a public getAllActiveProducts method if needed.
        // For now, if no category is present, the UI implies "no products" or "select category".
        // But if there's a route for "all products", we should handle it.
        // Let's assume this page is primarily category-driven given `where("category", "==", categoryName)`.
      }

      setProducts(data);
      setFiltered(data);
      setPage(1);
      setLoading(false);
    };

    fetchProducts();
  }, [categoryName]);

  return (
    <div className="max-w-[1300px] mx-auto px-6 py-12">

      {/* SAYFA BAŞLIĞI */}
      <h1 className="text-3xl font-bold text-center mb-10 capitalize">
        {readableCategory} Ürünleri
      </h1>

      <div className="flex flex-col lg:flex-row gap-10">

        {/* MOBILE FILTER TOGGLE */}
        <div className="lg:hidden w-full mb-6">
          <button
            className="w-full py-3 bg-fecos-surface border border-fecos-border rounded-xl font-bold text-fecos-text shadow-sm flex items-center justify-center gap-2 active:bg-gray-50 transition-colors"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          >
            <span>Filtrele</span>
            <span className={`transition-transform duration-200 ${isFilterOpen ? 'rotate-180' : ''}`}>▼</span>
          </button>
        </div>

        {/* SOL FİLTRE SIDEBAR */}
        <div className={`w-full lg:w-64 bg-fecos-surface p-6 rounded-xl shadow h-fit ${isFilterOpen ? 'block' : 'hidden lg:block'}`}>
          <h2 className="text-lg font-bold mb-4">Filtrele</h2>

          <label className="text-sm font-semibold text-gray-700">Form</label>
          <select
            className="w-full p-3 border rounded mt-2 mb-6"
            value={formFilter}
            onChange={(e) => setFormFilter(e.target.value)}
          >
            <option value="">Tümü</option>
            <option value="Tablet">Tablet</option>
            <option value="Kapsül">Kapsül</option>
            <option value="Sıvı">Sıvı</option>
            <option value="Çiğneme Tablet">Çiğneme Tablet</option>
          </select>
        </div>

        {/* ÜRÜN LİSTESİ */}
        <div className="flex-1">
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map(i => (
                <div key={i} className="h-80 bg-gray-100 rounded-xl animate-pulse" />
              ))}
            </div>
          ) : paginatedProducts.length === 0 ? (
            <p className="text-center text-gray-500 text-lg mt-10">
              Bu kategoriye ait ürün bulunamadı.
            </p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {paginatedProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}

          {/* SAYFALAMA */}
          {totalPage > 1 && (
            <div className="flex justify-center gap-3 mt-10">
              {Array.from({ length: totalPage }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`px-4 py-2 rounded-md ${page === i + 1
                    ? "bg-green-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ProductList;
